module.exports = __webpack_public_path__ + "static/media/Illus-Loyalty@3x.26284cff.png";